<template>
<div class="animated fadeIn manage-store">
  <div class="card dash-field">
    <div class="row m-0">
      <div class="card-body col-md-8">
        <h3>{{$t('STORESCHEDULEASOF')}}: {{moment(date).day(0).format('ddd-MMM/DD/YY')}}</h3>
      </div>
      <div class="col-md-4 m-auto">
        <button type="button" class="btn btn-primary" @click="showSummaryModal()">
          <!-- icon icon="plus"></icon --> {{$t('SCHEDUALSUMMARY')}}
        </button>
      </div>
    </div>
  </div>
  <div class="mt-4">
    <div class="">
      <div class="row mb-2">
        <div class="col-sm-6">
          <button type="button" class="btn btn-secondary" @click="getDateObject('previous')">
            <!-- icon icon="plus"></icon --> {{$t('PREVIOUSWEEK')}}
          </button>
        </div>
        <div class="col-sm-6">
          <button type="button" class="btn btn-secondary float-right" @click="getDateObject('next')">
            <!-- icon icon="plus"></icon --> {{$t('NEXTWEEK')}}
          </button>
        </div>
      </div>
      <div class="clear20">&nbsp;</div>
      <div class="row mb-2">
        <div class="col-sm-12">
          <table class="table table-foursight table-striped table-hover table-sm schedule-table">
            <thead>
              <tr>
                <th>{{$t('NAME')}}</th>
                <template v-for="item in dates">
                  <th>{{moment(item).format('ddd-MMM/DD/YY')}}</th>
                </template>
                <th>{{$t('WEEKLYTOTAL')}}</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="item in schedule">
                <tr aria-rowindex="1" class=" table-ellipsis">
                  <td>
                    {{item[0].name}}
                  </td>
                  <template v-for="i in item">
                    <td v-if="typeof i.scheduleNotSet === 'undefined'">
                      <p v-if="typeof i.totalWeekData === 'undefined' && typeof i.dailyTotal === 'undefined'"><b>
                          {{ moment(moment.utc(i.startTime).toDate()).local().format('hh:mm A')}} to {{moment(moment.utc(i.endTime).toDate()).local().format('hh:mm A')}}
                        </b>
                      </p>
                      <p>{{$t('SALESHRS')}} <span class="pull-right">{{i.salesTime | currency('', 1, { thousandsSeparator: ',', decimalSeparator: '.' })}}</span></p>
                      <p>{{$t('BREAKHRS')}} <span class="pull-right">{{i.breakTime }}</span></p>
                      <p>{{$t('OPHRS')}} <span class="pull-right">{{i.additionalTime | currency('', 1, { thousandsSeparator: ',', decimalSeparator: '.' })}}</span></p>
                      <p>{{$t('TOTALHRS')}} <span class="pull-right">{{i.totalTime | currency('', 1, { thousandsSeparator: ',', decimalSeparator: '.' })}}</span></p>
                      <div class="mt-2" v-if="typeof i.totalWeekData === 'undefined' && typeof i.dailyTotal === 'undefined'">
                        <button type="button" class="btn btn-delete" @click="deleteRow(i)">{{$t('DELETE')}}</button>
                        <button type="button" class="btn btn-edit-trans ml-2" @click="showModal(i)">{{$t('EDIT')}}</button>
                      </div>
                    </td>
                    <td v-else>
                      <p><b>{{$t('NOTSCHEDULED')}}</b></p>
                      <div class="mt-2">
                        <button type="button" class="btn btn-primary" @click="showModal(i)" v-if="i.enabled">{{$t('SCHEDULE')}}</button>
                      </div>
                    </td>
                  </template>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
  <b-modal ref="formmodal" :title="$t('SCHEDULEFORM')" ok-title="submit" hide-footer no-close-on-backdrop>
    <div class="d-block">
      <scheduleform v-bind:formData="formData" v-bind:formError="formError" v-bind:optionalHorus="optionalHorus" v-bind:hours="hours"></scheduleform>
    </div>
    <div class="text-right">
      <b-btn class="mt-3" variant="secondary-trans mr-4" @click="hideModal">{{$t('CANCEL')}}</b-btn>
      <b-btn class="mt-3" variant="primary" @click="submitData(formData)">{{$t('SAVE')}}</b-btn>
    </div>
  </b-modal>
  <b-modal ref="formsummarymodal" :title="$t('SCHEDULESUMMARYFORM')" ok-title="submit" hide-footer no-close-on-backdrop>
    <div class="d-block">
      <schedulesummaryform v-bind:scheduleSummary="scheduleSummary"></schedulesummaryform>
    </div>
    <div class="text-right">
      <b-btn class="mt-3" variant="secondary-trans mr-4" @click="hideSummaryModal">{{$t('CANCEL')}}</b-btn>
    </div>
  </b-modal>
</div>
</template>

<script>
import
{
  mapActions,
  mapGetters
}
from 'vuex'
import moment from 'moment';

import SchedualApi from '@/api/salesportal/Schedual'

import ScheduleForm from './ScheduleForm'
import ScheduleSummaryForm from './ScheduleSummaryForm'

export default
{
  name: 'ScheduleWin',
  props: ['storeId', 'tabIndex'],
  components:
  {
    scheduleform: ScheduleForm,
    schedulesummaryform: ScheduleSummaryForm
  },
  data: function()
  {
    return {
      date: moment().format('YYYY-MM-DD'),
      calendarDate: null,
      dates: [],
      schedule:
      {},
      scheduleSummary:
      {},
      optionalHorus: [],
      hours: [],
      formError:
      {},
      formData:
      {
        startTimeOut: '',
        endTimeOut: '',
        additionalTime: 0,
        userId: null,
        date: ''
      }
    }
  },
  created()
  {
    var me = this;
    me.setWeek();
    //me.getScheduleData();

    for (var i = 0; i <= 9; i += 0.5)
    {
      me.optionalHorus.push(
      {
        value: i,
        text: (i % 1 == 0) ? i + '.0 Hours' : i + ' Hours'
      })
    }
  },
  methods:
  {
    getDateObject(item)
    {
      var me = this;

      if (typeof item !== 'undefined' && item == 'previous')
      {
        me.date = moment(me.date).subtract(7, 'days').format('YYYY-MM-DD');
      }
      else if (typeof item !== 'undefined' && item == 'next')
      {
        me.date = moment(me.date).add(7, 'days').format('YYYY-MM-DD');
      }
    },
    setWeek()
    {
      var me = this;
      me.dates = [];
      for (var i = 0; i < 7; i++)
      {
        me.dates.push(moment(me.date).day(i).format('YYYY-MM-DD'));
      }
    },
    async getScheduleData()
    {
      var me = this;
      try
      {
        var data = await SchedualApi.selectSchedual(
        {
          date: me.date,
          storeId: me.storeId
        });
        if (data.error && data.error == true)
        {
          me.$notify.notice(data);
          me.loading = false;
          return;
        }

        me.schedule = data.root;
      }
      catch (e)
      {
        me.$notify.notice(e);
      }
    },
    async getScheduleSummary()
    {
      var me = this;
      try
      {
        var data = await SchedualApi.getScheduleSummary(
        {
          date: me.date,
          storeId: me.storeId
        });
        if (data.error && data.error == true)
        {
          me.$notify.notice(data);
          me.loading = false;
          return;
        }

        me.scheduleSummary = data.root;
      }
      catch (e)
      {
        me.$notify.notice(e);
      }
    },
    showModal(item)
    {
      var me = this;
      if (typeof item != 'undefined')
      {
        me.formData = item;
      }

      for (const time of item.hours)
      {
        me.hours.push(moment.utc(time, 'HH').local().format('HH'));
      }
          
      if (typeof item.startTime != 'undefined')
      {        
        me.formData = item;

        var startTimeOut = {
          hh: moment.utc(item.startTime).local().format('hh'),
          mm: moment.utc(item.startTime).local().format('mm'),
          A: moment.utc(item.startTime).local().format('A')
        }

        var endTimeOut = {
          hh: moment.utc(item.endTime).local().format('hh'),
          mm: moment.utc(item.endTime).local().format('mm'),
          A: moment.utc(item.endTime).local().format('A')
        }
        

        me.$set(me.formData, 'startTimeOut', startTimeOut);
        me.$set(me.formData, 'endTimeOut', endTimeOut);
      }   
      if(typeof me.formData.additionalTime == 'undefined') me.$set(me.formData, 'additionalTime', 0);
      
      this.$refs.formmodal.show()
    },
    async submitData(item)
    {
      var me = this;
      try
      {
        var startTime = item.date + ' ' + item.startTimeOut.hh + ':' + item.startTimeOut.mm + ' ' + item.startTimeOut.A
        me.$set(item, 'startTime', moment(startTime, 'YYYY-MM-DD hh:mm A').utc().format('YYYY-MM-DD HH:mm:ss'));
        me.$set(item, 'startTimeLocal', moment(startTime, 'YYYY-MM-DD hh:mm A').format('YYYY-MM-DD HH:mm:ss'));

        var endTime = item.date + ' ' + item.endTimeOut.hh + ':' + item.endTimeOut.mm + ' ' + item.endTimeOut.A;
        me.$set(item, 'endTime', moment(endTime, 'YYYY-MM-DD hh:mm A').utc().format('YYYY-MM-DD HH:mm:ss'));
        me.$set(item, 'endTimeLocal', moment(endTime, 'YYYY-MM-DD hh:mm A').format('YYYY-MM-DD HH:mm:ss'));
       
        var data = await SchedualApi.submitData(item);
        if (data.error)
        {
          me.$notify.notice(data);
          me.formError = data;
        }
        else
        {
          me.$notify.notice(data);
          me.hideModal();
          await me.getScheduleData();
        }
      }
      catch (e)
      {
        me.$notify.notice(e);
      }
    },
    hideModal()
    {
      var me = this;
      this.$refs.formmodal.hide();

      me.formData = {
        startTime: '',
        endTime: '',
        additionalTime: 0,
        userId: null,
        date: ''
      }
    },
    async deleteRow(item)
    {
      var me = this;
      try
      {
        me.$store.commit('setModalAlert',
        {
          text: me.$i18n.t('AREYOUSHURE'),
          btnAction: async function()
          {
            var data = await SchedualApi.deleteRow(
            {
              date: item.date,
              userId: item.userId
            });
            me.$notify.notice(data);
            await me.getScheduleData();
          }
        })
      }
      catch (e)
      {
        me.$notify.notice(e);
      }
    },
    showSummaryModal()
    {
      var me = this;
      me.getScheduleSummary();
      this.$refs.formsummarymodal.show()
    },
    hideSummaryModal()
    {
      var me = this;
      this.$refs.formsummarymodal.hide();
    }
  },
  watch:
  {
    date(val)
    {
      var me = this;
      me.setWeek();
      me.getScheduleData();
    },
    calendarDate(val)
    {
      var me = this;
      me.date = moment(val).format('YYYY-MM-DD');
    },
    async tabIndex(val)
    {
      var me = this;
      try 
      {
        if(val == 2)
        {
          await me.getScheduleData();
        } 
      } 
      catch (error) 
      {
        me.$notify.notice(e);
      }           
    }
  },
  computed:
  {

  }
}
</script>
